<template>
  <div style="height: 100%">
    <div id="grid-wrapper" style="width: 100%; height: 100%">
      <ag-grid-vue style="width: 100%; height: 520px;" class="ag-theme-alpine " :columnDefs="columnDefs"
        :autoGroupColumnDef="autoGroupColumnDef" :defaultColDef="defaultColDef" :rowSelection="rowSelection"
        :rowGroupPanelShow="rowGroupPanelShow" :pivotPanelShow="pivotPanelShow" :pagination="true"
        :paginationPageSize="paginationPageSize" :paginationNumberFormatter="paginationNumberFormatter"
        :rowData="rowData" @first-data-rendered="onFirstDataRendered">
      </ag-grid-vue>

    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>
</template>

<script>
import SpanServiceNo from "@/components/prospectservice/SpanServiceNo.vue";
import ButtonPage from "@/components/prospectservice/ButtonPage.vue";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'


export default {
  name: "History",
  components: {
    SpanServiceNo,
    LoadingBs5,
    ButtonPage
  },
  data() {
    return {
      columnDefs: [
        { headerName: "เลขที่รับงานบริการ", field: "REQUEST_NO", cellRenderer: 'SpanServiceNo', flex: 1, lockPosition: 'left', width: 150, maxWidth: 150, filter: false, sortable: true },
        { headerName: "รายการที่ขอแก้ไข", field: "JOB_DESC", flex: 1, lockPosition: 'left', filter: false, sortable: true },
        { lockPosition: 'right', cellRenderer: 'ButtonPage', colId: 'params', width: 50, maxWidth: 50, filter: false, sortable: false },
      ],
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        sortable: true,
        flex: 1,
        minWidth: 100,
        wrapText: true,
        autoHeight: true,
        cellClass: 'locked-col',
        filter: true,
      },
      autoGroupColumnDef: null,
      rowSelection: null,
      rowGroupPanelShow: null,
      pivotPanelShow: null,
      paginationPageSize: null,
      paginationNumberFormatter: null,
      rowData: [],
      Loading: true,
    };
  },
  mounted() {
    if (this.$store.state.USER_NAME == '') {
      this.$router.push('/');
    }

    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetHistoryProspect?", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
      if (res.status == 200) {
        if (res.data.length > 0) {
          res.data.forEach(item => {
            this.rowData.push(item);
          });
          this.Loading = false;
        }
        else {
          this.rowData = [];
          this.Loading = false;
        }
      }
    });

    http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
      if (response.status == 200) {
        this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
        this.$store.state.USER_NAME = response.data.USER_NAME;
      }
      else {
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
      }
    }).catch((error) => {
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
      }).then(() => {
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
      });
    });
  },
  created() {
    this.autoGroupColumnDef = {
      headerName: 'Group',
      minWidth: 170,
      field: 'athlete',
      valueGetter: (params) => {
        if (params.node.group) {
          return params.node.key;
        } else {
          return params.data[params.colDef.field];
        }
      },
    };
    this.rowSelection = 'multiple';
    this.rowGroupPanelShow = 'always';
    this.pivotPanelShow = 'always';
    this.paginationPageSize = 10;
    this.paginationNumberFormatter = (params) => {
      return '[' + params.value.toLocaleString() + ']';
    };
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.paginationGoToPage(0);
    },
    onPageSizeChanged() {
      var value = document.getElementById('page-size').value;
      this.gridApi.paginationSetPageSize(Number(value));
    },
  },
};
</script>

<style scoped>
.ag-theme-alpine {
  --ag-font-size: 17px;
  --ag-font-family: "DB Heavent";
}
</style>